<template>
    <section class="credit-card-modal">
        <ds-modal
            :is-open="isCreditCardModalOpen"
            class="regular-credit-card-modal"
            show-close
            :sub-title="fullName"
            :size="modalSize"
            :title.sync="modalTitle"
            @close="modalClose"
        >
            <template #header>
                <ds-button
                    v-if="showAction"
                    data-qa="save-button"
                    :disabled="actionDisabled"
                    @click="save"
                >
                    Save
                </ds-button>
            </template>

            <template #default>
                <div class="credit-card-modal">
                    <div class="credit-card-info">
                        <span>Credit card info</span>
                    </div>
                    <div>
                        <div class="credit-card-details">
                            <div>
                                <ds-select-field
                                    v-model="contactCreditCard.cardType"
                                    :options="cardTypes"
                                    bind-value-only
                                    class="input-field"
                                    name="cardType"
                                    required
                                    label="Card Type"
                                    :submitted="submitted"
                                    data-qa="card-type"
                                />
                            </div>

                            <span class="date-space" />

                            <ds-input-field
                                v-model="contactCreditCard.cardNumber"
                                class="input-border"
                                name="cardNumber"
                                label="Card number"
                                required
                                :submitted="submitted"
                                data-qa="formCustomField_TEXT"
                            />
                        </div>

                        <div class="date-fields">
                            <ds-select-field
                                v-model="contactCreditCard.expirationMonth"
                                :options="expirationMonths"
                                class="input-field"
                                name="expirationMonth"
                                required
                                bind-value-only
                                label="Expiration month"
                                :submitted="submitted"
                            />

                            <span class="date-space" />

                            <ds-select-field
                                v-model="contactCreditCard.expirationYear"
                                :options="expirationYears"
                                bind-value-only
                                class="input-field"
                                name="expirationYear"
                                required
                                label="Expiration year"
                                :submitted="submitted"
                            />
                        </div>

                        <div class="billing-info">
                            <span>Billing info</span>
                        </div>
                    </div>

                    <div>
                        <ds-input-field
                            v-model.trim="contactCreditCard.nameOnCard"
                            class="input-border"
                            name="billingName"
                            label="Billing name"
                            required
                            :submitted="submitted"
                        />

                        <ds-input-field
                            v-model="contactCreditCard.billAddress1"
                            class="input-border"
                            name="address"
                            label="Address"
                            required
                            :submitted="submitted"
                        />

                        <ds-input-field
                            v-model="contactCreditCard.billAddress2"
                            class="input-border"
                            name="appSuiteOther"
                            label="Appt/Suite/Other"
                        />

                        <ds-input-field
                            v-model="contactCreditCard.billCity"
                            class="input-border"
                            name="city"
                            label="City"
                            required
                            :submitted="submitted"
                        />

                        <div class="credit-card-details">
                            <ds-input-field
                                v-model="contactCreditCard.billState"
                                class="input-border"
                                name="stateProvince"
                                label="State/Province"
                                required
                                :submitted="submitted"
                            />

                            <span class="date-space" />

                            <ds-input-field
                                v-model="contactCreditCard.billZip"
                                class="input-border"
                                name="zipCode"
                                label="Zip code"
                                required
                                :submitted="submitted"
                            />
                        </div>

                        <div class="credit-card-bill-country">
                            <ds-multiselect
                                v-model="contactCreditCard.billCountry"
                                :options="countryList"
                                bind-value-only
                                name="country"
                                searchable
                                required
                                placeholder="Country"
                                :submitted="submitted"
                            />
                        </div>

                        <ds-input-field
                            v-model="contactCreditCard.phoneNumber"
                            class="input-border"
                            name="phone"
                            label="Phone"
                        />

                        <ds-input-field
                            v-model="contactCreditCard.email"
                            class="input-border"
                            name="email"
                            label="Email"
                        />
                    </div>

                    <div>
                        <div class="card-validation">
                            Card validation
                        </div>

                        <div class="validation-status">
                            <span>Status</span>
                            <!-- eslint-disable vue/no-v-html -->
                            <span class="status-message" v-html="contactCreditCard.statusStr || 'This card has not been validated'" />
                        </div>

                        <div class="message">
                            <span>Message</span>

                            <span class="message-validation">
                                {{ contactCreditCard.statusMsg || 'None' }}
                            </span>
                        </div>
                    </div>
                </div>
            </template>
        </ds-modal>
    </section>
</template>
<script>
import axios from 'axios';

export default {

    props: {
        contact: Object,
    },

    data() {
        return {
            isCreditCardModalOpen: false,
            showAction: true,
            actionDisabled: false,
            modalSize: 'med',
            modalTitle: 'Add a credit card',
            saving: false,
            submitted: false,
            countryList: [],
            cardTypes: [],
            expirationMonths: [],
            expirationYears: [],
            contactCreditCard: {
                id: '',
                cardType: '',
                cardNumber: '',
                contactId: this.contact.id,
                expirationMonth: '',
                expirationYear: '',
                nameOnCard: '',
                billAddress1: '',
                billAddress2: '',
                billCity: '',
                billState: '',
                billZip: '',
                billCountry: '',
                phoneNumber: '',
                email: '',
                statusStr: '',
                statusMsg: '',
            },
        };
    },

    created() {
        this.contactCreditCard.nameOnCard = this.fullName;
        this.contactCreditCard.email = this.contact.email;
    },

    computed: {
        fullName() {
            const name = `${this.contact?.firstName} ${this.contact?.lastName}`;

            return name.trim();
        },
    },

    methods: {
        showModal(id) {
            if (id > 0) {
                this.modalTitle = 'Edit credit card';
                this.load(id);
            }
            this.initTab();
            this.isCreditCardModalOpen = true;
        },

        save() {
            if (this.contactCreditCard?.cardNumber !== ''
                    && this.contactCreditCard?.cardType !== ''
                    && this.contactCreditCard?.expirationMonth !== ''
                    && this.contactCreditCard?.expirationYear !== ''
                    && this.contactCreditCard?.nameOnCard !== ''
                    && this.contactCreditCard?.billAddress1 !== ''
                    && this.contactCreditCard?.billCity !== ''
                    && this.contactCreditCard?.billState !== ''
                    && this.contactCreditCard?.billZip !== ''
                    && this.contactCreditCard?.billCountry !== '') {
                this.saving = true;

                this.addCreditCard();
            } else {
                this.submitted = true;
                this.saving = false;
            }
        },

        modalClose() {
            this.nestedModal_reset();
            this.isCreditCardModalOpen = false;
        },

        async addCreditCard() {
            const errorMessage = this.contactCreditCard?.id > 0 ? 'Unable to update Credit Card' : 'Unable to save credit card';
            const successMessage = this.contactCreditCard?.id > 0 ? 'Credit card updated successfully' : 'Credit card added successfully';

            try {
                await axios.post('/app/creditCard/addCreditCard', this.contactCreditCard);
                this.$toast({ message: successMessage });
                this.$root.$emit('RELOAD_CREDIT_CARD_DETAILS', true);
                this.modalClose();
            } catch (error) {
                this.$error({ message: errorMessage });
            }
        },

        nestedModal_reset() {
            this.saving = false;
            this.submitted = false;
            this.contactCreditCard.id = '';
            this.contactCreditCard.cardType = '';
            this.contactCreditCard.cardNumber = '';
            this.contactCreditCard.expirationMonth = '';
            this.contactCreditCard.expirationYear = '';
            this.contactCreditCard.nameOnCard = this.fullName;
            this.contactCreditCard.billAddress1 = '';
            this.contactCreditCard.billAddress2 = '';
            this.contactCreditCard.billCity = '';
            this.contactCreditCard.billState = '';
            this.contactCreditCard.billZip = '';
            this.contactCreditCard.billCountry = '';
            this.contactCreditCard.phoneNumber = '';
            this.contactCreditCard.email = '';
            this.contactCreditCard.contactId = this.contact.id;
            this.modalTitle = 'Add a credit card';
        },

        initTab() {
            this.loadAllCreditCardDropDowns();
        },

        async loadAllCreditCardDropDowns() {
            try {
                const response = await axios.get('/app/creditCard/loadCreditCardDropDown');

                this.countryList = response.data.countryList;

                this.countryList = Object.keys(this.countryList).map((key) => {
                    return { label: this.countryList[key], value: key };
                });

                this.cardTypes = response.data.cardTypes;
                this.cardTypes = Object.keys(this.cardTypes).map((key) => {
                    return { label: this.cardTypes[key], value: key };
                });

                this.expirationMonths = response.data.expirationMonths;
                this.expirationMonths = Object.keys(this.expirationMonths).map((key) => {
                    return { label: this.expirationMonths[key], value: key };
                }).sort((prev, next) => prev.label.localeCompare(next.label));

                this.expirationYears = response.data.expirationYears;
                this.expirationYears = Object.keys(this.expirationYears).map((key) => {
                    return { label: this.expirationYears[key], value: key };
                });
            } catch (error) {
                this.$error({ message: 'error occurred while getting credit drop downs' });
            }
        },

        async load(id) {
            try {
                const response = await axios.get(`/app/creditCard/loadCreditCardById/${id}`);

                this.contactCreditCard = response.data;
            } catch (error) {
                this.$error({ message: `Unable to load credit card details by id:${id}` });
            }
        },
    },
};

</script>

<style lang="scss">
.credit-card-bill-country {
    input.search-input {
        margin-bottom: 3px;
    }
}

.credit-card-modal > .regular-credit-card-modal {
    .action > .small {
        width: 100%;
        height: 40px;
        font-size: 0.875rem;
    }

    .modal-header .navigation-button {
         margin: 0;
    }
}
</style>

<style lang="scss" scoped>
.date-fields {
    display: flex;
    justify-content: space-between;
}

.credit-card-modal {
    display: flex;
    flex-direction: column;
}

.date-space {
    margin: $spacing-100 $spacing-200 0 $spacing-200;
    vertical-align: center;
}

.date-field {
    flex: 2;
}

.input-border {
    width: 100%;
}

.billing-info {
    font-size: $font-size-md;
    color: $color-gray-darkest;
    margin-bottom: $spacing-200;
}

.credit-card-info {
    font-size: $font-size-md;
    color: $color-gray-darkest;
    margin-bottom: $spacing-200;
}

.credit-card-details{
    display: flex;
}

.date-space {
    margin: 6px;
    vertical-align: center;
}

.card-validation {
    font-size: $font-size-md;
}

.validation-status {
    margin-top: $spacing-200;
    display: grid;
    color: $color-gray-dark;
}

.status-message {
    font-size: $font-size-md;
    color: $color-gray-darker;
}

.message {
    margin-top: $spacing-200;
    display: grid;
    color: $color-gray-dark;
}

.message-validation {
    font-size: $font-size-md;
    color: $color-gray-darker;
}

@media screen and ( $small ) {
    .input-row {
        display: flex;
        flex-direction: column;
    }

    .credit-card-modal {
        flex-direction: column;
        margin: auto;
    }
}
</style>
